import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    CircularProgress,
    Typography,
    Box,
    IconButton,
    Avatar,
    List,
    ListItem,
    ListItemText
} from '@mui/material';
import { Close as CloseIcon, Person as PersonIcon } from '@mui/icons-material';
import axios from 'axios';

const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB'); // Formats the date as DD/MM/YYYY
};

const WorkerVacationsDialog = ({ open, onClose, userId }) => {
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!userId) return;

        const fetchUserData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetVacantionHistoryByUserid?Userid=${userId}`);
                if (response.data.success) {
                    setUserData(response.data.data);
                } else {
                    // Handle specific error messages from the API
                    setError(response.data.errors[0].message);
                }
                setLoading(false);
            } catch (error) {
                setError('An error occurred while fetching data.');
                setLoading(false);
            }
        };

        fetchUserData();
    }, [userId]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box display="flex" alignItems="center">
                        <Avatar sx={{ bgcolor: 'primary.main', marginRight: 2 }}>
                            <PersonIcon />
                        </Avatar>
                        <Typography variant="h6">შვებულების ისტორია</Typography>
                    </Box>
                    <IconButton onClick={onClose} edge="end" aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                {loading ? (
                    <Box display="flex" justifyContent="center">
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Typography color="error">{error}</Typography>
                ) : userData && userData.length > 0 ? (
                    <List>
                        {userData.map((item, index) => (

                            <>
                                <ListItem key={index} divider>
                                    <ListItemText
                                        primary={
                                            item.end && new Date(item.end).getFullYear() === 2100
                                                ? "შვებულების პერიოდი: უვადო შვებულება"
                                                : `შვებულების პერიოდი: ${formatDate(item.start)} - ${formatDate(item.end)}`
                                        }
                                        secondary={`მოვალეობის შემსრულებელი: ${item.temporaryExecutorUserFullName}`}
                                    />
                                </ListItem>
                            </>


                        ))}
                    </List>
                ) : (
                    <Typography color="textSecondary">არაფერი მოიძებნა!</Typography>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default WorkerVacationsDialog;
